export function isANumber(str) {
  return !/\D/.test(str);
}
